
export class SubscriptionSetPayment {
    id: string;
    customerId: string;
    partnerId: string;
    entityName: string;
    subscriptionSetId: string;
    status: SubscriptionSetPaymentStatus;
    amount: number;
    type: SubscriptionSetPaymentType;
    paymentNumber: string;
    items: SubscriptionSetPaymentItem[];
    creationTimestamp: number;
    creationUserEmail: string;
    creationUserFullName: string;
    dueTimestamp: number;
    paymentTimestamp: number;
    confirmationTimestamp: number;
    confirmationUserEmail: string;
    errorReason: string;
    nextRetryTimestamp: number;
}

export enum SubscriptionSetPaymentStatus {
    PENDING = 'PENDING',
    PAID = 'PAID'
}

export enum SubscriptionSetPaymentType {
    OTHER = 'OTHER',
    STRIPE = 'STRIPE'
}

export class SubscriptionSetPaymentItem {
    itemId: string;
    category: string;
    name: string;
    operation: string;
    amount: number;
}